import { Component } from '../helpers/helper';
import { state } from '../state';
import { transport } from '../firebaseTransport';

const REACTIONS = ['👍', '❤️', '😂', '😮', '👏', '🎉'];

export const ReactionPanel = Component((p: { onClose: () => void }) => {
	function sendReaction(emoji: string) {
		if (!state.user) return;
		const id = Date.now().toString(36) + Math.random().toString(36).slice(2);
		transport
			.broadcast({ type: 'reaction', emoji, user_id: state.user.id, reaction_id: id })
			.catch(err => console.error('reaction broadcast failed', err));
		p.onClose();
	}

	return () => (
		<div class="reaction-panel-popover" onClick={(e: MouseEvent) => e.stopPropagation()}>
			{REACTIONS.map(emoji => (
				<button key={emoji} onClick={() => sendReaction(emoji)} title={emoji}>
					{emoji}
				</button>
			))}
		</div>
	);
});
